define({
  pubcourse: require('./pubcourse.js'),
  common: require('./common.js')
})